<template>
  <div id="sac-tooltip">
    <img
      alt="Ruler"
      src="@shared/assets/img/general/info-dark.png"
      class="img-size-20 clickable"
    >
    <div class="tooltip-text">
      {{ tip }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'SACTip',
  props: {
    tip: String,
  },
};
</script>

<style scoped lang="scss">
#sac-tooltip {
  position: relative;
  .tooltip-text {
    font-size: 14px;
    background-color: $N90;
    color: $WHITE;
    padding: 10px;
    border-radius: 3px;
    opacity: 0.9;
    display: none;
    position: absolute;
    z-index: 10;
    left: 25px;
    top: -7px;
    min-width: 500px;
  }
  &:hover {
    .tooltip-text {
      display: block;
    }
  }
}

</style>
